
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/thank-you-for-applying",
      function () {
        return require("private-next-pages/jobs/thank-you-for-applying.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/thank-you-for-applying"])
      });
    }
  